export const SUPPORT_LINK = 'https://mindlogger.atlassian.net/servicedesk/customer/portals';
